import React from "react";
import {observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const DomainExpiredDialog = observer(() => {
    const {modalStore, generalStore} = useStores();

    function closeModal() {
        modalStore.isDomainExpiredModalOpen = false;
    }


    return (
        <GeneralDialog
            openControl='isDomainExpiredModalOpen'
            className='blue-dialog domain-expired-modal'
            title={generalStore.translate('domainExpired')}
            body={<div>
                {generalStore.translate('itSeemsThatYourWorkspaceBeenExpired')}.<br/> {generalStore.translate('ifYouWantToReactivateItPlease')}
                <a href='mailto:support@frontline.io' target='_blank'
                   rel='noreferrer'>{generalStore.translate('contactUs')}</a>
            </div>}
            confirmText={generalStore.translate('gotIt')}
            onConfirm={closeModal}
            noCancel
        />
    );
});
export default DomainExpiredDialog;
